import { Button, DatePicker, Modal, Radio, Upload, message } from 'antd';
import React, { Component } from 'react'
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import moment from 'moment';
import ExportUtil from '../../../common/ExportUtil';
import { xToken } from '../../../common/AjaxRequest';
import $ from '../../../common/AjaxRequest';

const RadioGroup = Radio.Group;

export default class Update extends Component {

    state = {
        params: {},
        visible: false,
        fileList: [],
    }

    show = (record) => {
        const { isSiteFormalAuthorization = '', authorizationFileList = [] } = record;
        authorizationFileList.forEach(el => {
            el.response = { fileMetaId: el.fileMateId };
            el.uid = el.fileMateId;
        });
        this.setState({
            params: {
                ...record,
                isSiteFormalAuthorization: isSiteFormalAuthorization ? isSiteFormalAuthorization : '1',
            },
            fileList: authorizationFileList,
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    submit = () => {
        const { params } = this.state;
        const { investigationSiteId, userId, isSiteFormalAuthorization, crcRequirementInfoType, authorizationDate } = params;
        const { curRole } = sessionStorage;
        const isCRC = curRole == 'CRC';
        if (!isSiteFormalAuthorization) {
            return message.warning('请输入是否在site授权表上正式授权');
        }
        if (!crcRequirementInfoType) {
            if (isCRC) {
                return message.warning('请联系PM维护工作类型');
            } else {
                return message.warning('请输入工作类型');
            }
        }
        if (isSiteFormalAuthorization == '1' && !authorizationDate) {
            return message.warning('请输入授权时间');
        }
        Fetch.post(API_URL.contract.setUserRoleInvestigationSiteCrcData, {
            siteId: investigationSiteId,
            userId,
            isSiteFormalAuthorization,
            crcRequirementInfoType,
            authorizationDate,
        }).then((res) => {
            message.success(res.success);
            this.hide();
            this.props.loadData();
        }).catch(err => {
            console.error(err);
        });
    }

    handleChange = (value, key) => {
        const { params } = this.state;
        if (key == 'isSiteFormalAuthorization') {
            params[key] = value;
            params.authorizationDate = undefined;
        }else{
            params[key] = value;
        }
        this.setState({ params });
    }

    handleFileChange = ({ file, fileList }) => {
        if (file.status == "done") {
            if (file.response.error) {
                message.error(file.response.error);
                file.status = 'removed';
                const fileData = [...this.state.fileList];
                const index = fileData.indexOf(file);
                fileList.splice(index, 1);
            } else if (file.response.success) {
                message.success('上传附件成功');
            }
        }
        this.setState({ fileList });
    }

    beforeUpload = file => {
        const { fileList = [] } = this.state;
        const isLt30M = file.size / 1024 / 1024 <=30;
        if (fileList.length >= 10) {
            message.warning('最多上传10个附件');
            return false;
        }
        if (!isLt30M) {
            message.warning('文件大小不能超过30M');
            return false;
        }
    }

    handleRemove = (file) => {
        const options = {
            method: 'POST',
            url: API_URL.evaluate.deleteEnclosureFile,
            data: {
                fileMetaId: file.response.fileMetaId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
            }
        };
        $.sendRequest(options);
    }

    downLoadFile = (e, fileMetaId) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId }, null, url);
    }

    render() {
        const { params, visible, fileList } = this.state;
        const { userCompellation, isSiteFormalAuthorization, crcRequirementInfoType, authorizationDate, userRoleInvestigationSiteCrcId } = params;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        const { curRole } = sessionStorage;
        const isCRC = curRole == 'CRC';
        return (
            <Modal
                title={`修改CRC`}
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                maskClosable={false}
                width="550px"
            >
                <div className="modal-content" style={{ padding: 0 }}>
                    <ul className="modal-list">
                        <li className="modal-item" style={{ lineHeight: '28px' }}>
                            <div className="item-left">CRC:</div>
                            <div className="item-right">{userCompellation}</div>
                        </li>
                        <li className="modal-item" style={{ lineHeight: '28px' }}>
                            <div className="item-left">{asterisk}是否在site授权表上正式授权:</div>
                            <div className="item-right">
                                <RadioGroup
                                    value={isSiteFormalAuthorization}
                                    disabled={isCRC}
                                    onChange={e=>this.handleChange(e.target.value, 'isSiteFormalAuthorization')}
                                >
                                    <Radio value={'0'}>否</Radio>
                                    <Radio value={'1'}>是</Radio>
                                </RadioGroup>
                            </div>
                        </li>
                        {isSiteFormalAuthorization == '1' &&
                            <li className="modal-item" style={{ lineHeight: '28px' }}>
                                <div className="item-left">{asterisk}授权时间:</div>
                                <div className="item-right">
                                    <DatePicker
                                        placeholder='请选择'
                                        style={{ width: 220 }}
                                        value={authorizationDate ? moment(authorizationDate) : null}
                                        onChange={(date, dateString) => this.handleChange(dateString, 'authorizationDate')}
                                    />
                                </div>
                            </li>
                        }
                        {isSiteFormalAuthorization == '1' &&
                        <li className="modal-item" style={{ lineHeight: '28px' }}>
                            <div className="item-left">授权证明文件:</div>
                            <div className="item-right">
                                <Upload
                                    action={API_URL.evaluate.uploadEnclosureFile}
                                    data={{
                                        relateId: userRoleInvestigationSiteCrcId,
                                        curUserId: sessionStorage.userId,
                                        curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                        uploadType: 'AUTHORIZATION_FILE',
                                    }}
                                    fileList={fileList}
                                    beforeUpload={this.beforeUpload}
                                    onChange={this.handleFileChange}
                                    onRemove={this.handleRemove}
                                    downLoadFile={this.downLoadFile}
                                    headers={xToken}
                                >
                                    <Button style={{ width: 80 }}>选择文件</Button>
                                </Upload>
                            </div>
                        </li>}
                        <li className="modal-item" style={{ lineHeight: '28px' }}>
                            <div className="item-left">{asterisk}工作类型:</div>
                            <div className="item-right">
                                <RadioGroup
                                    value={crcRequirementInfoType}
                                    disabled={isCRC}
                                    onChange={e=>this.handleChange(e.target.value, 'crcRequirementInfoType')}
                                >
                                    <Radio value={'SSU_LEAD'}>SSU主导</Radio>
                                    <Radio value={'PRE_START_ASSISTANCE'}>启动前协助</Radio>
                                    <Radio value={'AFTER_STARTUP_MEMBER'}>启动后人员</Radio>
                                    <Radio value={'SSU_LEAD_AFTER_STARTUP_MEMBER'}>SSU主导+启动后</Radio>
                                    <Radio value={'PRE_AFTER_STARTUP_MEMBER'}>启动前+启动后</Radio>
                                </RadioGroup>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/member/crcInfo/Update.js